import styled from "@emotion/styled";

const minSize = "calc(150px + 7vw)";

const Grid = styled.div(({ theme }) => ({
  display: "grid",
  gap: theme.spacing.gap,
  gridTemplateColumns: "100%",
  "@media (min-width: 440px)": {
    gridTemplateColumns: `repeat(auto-fill, minmax(min(${minSize}, 50% - 1rem), 1fr))`,
  },
  "@media (min-width: 1440px)": {
    gridTemplateColumns: `repeat(auto-fill, minmax(min(280px, 50% - 1rem), 1fr))`,
  },
}));

interface GridPlaceholderProps {
  cols: number;
  length: number;
}

/**
 * Fill out a <Grid> component with empty children to specified column size
 */
function GridPlaceholders({ cols, length }: GridPlaceholderProps) {
  const placeholders = cols - length;

  if (placeholders <= 0) return null;

  return (
    <>
      {Array.from({ length: placeholders }, (_, i) => (
        <div key={i} />
      ))}
    </>
  );
}

export { Grid, GridPlaceholders };
